import type { PaginatedList } from '../../stores/common/padinated-list';
import {
  toQueryString,
  type PaginationQueryParamsWithStatus
} from '../../stores/common/pagination-query-params';
import { makeGet, makePatch, makePost } from '../../utils/call-api-endpoint';
import type { Envelope } from '../../utils/envelope';
import type { Perfil, PerfilResumen } from './perfil';

export async function obtenerPerfilesPaginados(
  params: PaginationQueryParamsWithStatus
): Promise<Envelope<PaginatedList<PerfilResumen>>> {
  const response = await makeGet<PaginatedList<PerfilResumen>>(
    `/perfiles/paginados?${toQueryString(params)}`
  );
  return response;
}

export async function obtenerPerfilPorId(id: number): Promise<Envelope<Perfil>> {
  const response = await makeGet<Perfil>(`/perfiles/${id}`);
  return response;
}

export async function obtenerPerfilesActivos(): Promise<Envelope<PerfilResumen[]>> {
  const response = await makeGet<PerfilResumen[]>(`/perfiles/activos`);
  return response;
}

export interface RegistrarPerfilRequest {
  nombre: string;
  permisos: ModuloPermiso[];
}

export interface ModuloPermiso {
  idModulo: string;
  idPermiso: string;
}

export async function registrarPerfil(request: RegistrarPerfilRequest): Promise<Envelope<number>> {
  const response = await makePost<RegistrarPerfilRequest, number>('/perfiles', request);
  return response;
}

export interface ActualizarPerfilRequest {
  nombre: string;
  permisos: ModuloPermiso[];
}

export async function actualizarPerfil(
  id: number,
  request: ActualizarPerfilRequest
): Promise<Envelope<unknown>> {
  const response = await makePatch<ActualizarPerfilRequest, unknown>(`/perfiles/${id}`, request);
  return response;
}

export async function desactivarPerfil(id: number): Promise<Envelope<unknown>> {
  const response = await makePatch(`/perfiles/${id}/desactivar`);
  return response;
}
